import React, { FC } from 'react';
import styles from './ParkIndex.module.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {Helmet} from "react-helmet";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useRecoilState } from 'recoil';
import { parksState } from '../../../atoms/parks';
import { useNavigate } from 'react-router-dom';
import GenericTable from './GenericTable';

const ParkIndex = () => {
  const [parks, setParks] = useRecoilState(parksState);
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    { field: 'alpha', headerName: 'Park Alpha', width: 200 },
    { field: 'name', headerName: 'Park Name', width: 400, renderCell: (cellValues) => {
      return (
        <>
          <span style={{color: "#0000EE"}}>{cellValues.row.name}</span>
        </>    
      );
    } },
    { field: 'code', headerName: 'Park Code', width: 200 },
  ];

  const handleRowClick = (row, event) => { 
    console.log('rowArgs', row);
    let parkAlphaList = [];
    parkAlphaList.push(row);
    let obj = {parkAlphaList: parkAlphaList};
    navigate('/searchResults', {state: {filterText: '', filterOptions: obj}});

  }

  return (
    <>    
      <div className="search-results">
        <Helmet>
            <meta charSet="utf-8"/>
            <title>Park Index Page</title>
        </Helmet>

        <div className="center" style={{ paddingBottom: 60, width: '100%' }}>
          <h2 className="center" style={{fontWeight: 'bolder'}}>Park Index</h2>
          <GenericTable parks={parks} handleRowClick={handleRowClick}/>
          {/* <DataGrid 
            rowHeight={100}
            sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
            '.MuiDataGrid-row': {cursor: 'pointer', borderBottom: 1},
            '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
            '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
            '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
           }}
          rows={parks.map((result, index) => (
              {
                id: result.id, 
                alpha: result.alpha,
                name: result.name,
                code: result.code,
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 650 },
              },
            }}
            pageSizeOptions={[650, 1000]}
            onRowClick={handleRowClick}
            loading={!parks.length}
          /> */}
        </div>
      </div>
    </>
  );
}
 

export default ParkIndex;